"use client"

import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { useAppContext } from "@/context/app"
import clsx from "clsx"
import { X } from "lucide-react"
import { useState } from "react"
import CategoryTree from "../CategoryTree"
import classes from "./navTrigger.module.css"
import Link from "next/link"
import { createPortal } from "react-dom"

const DRAWER_CLASS_NAME = "mobile-nav-menu-drawer"

const NavigationTrigger = () => {
  const [open, setOpen] = useState(false)

  const [{ headerVisibleHeight }] = useAppContext()

  return (
    <>
      {createPortal(
        <style>
          {`
            .${DRAWER_CLASS_NAME}{
              height:calc(100vh - ${headerVisibleHeight}px);
            }

            @supports (height:100dvh) {
              .${DRAWER_CLASS_NAME}{
                height:calc(100dvh - ${headerVisibleHeight}px);
              }
            }
          `}
        </style>,
        document.head
      )}
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <div className="flex items-center justify-center">
            {open ? (
              <X className="h-[28px] w-[28px] text-primary" />
            ) : (
              <span className={classes.icon} />
            )}
          </div>
        </SheetTrigger>
        <SheetContent
          side={"left"}
          className={clsx("w-[360px] overflow-auto p-0 ", DRAWER_CLASS_NAME)}
          style={{ marginTop: headerVisibleHeight }}
          maskStyle={{ marginTop: headerVisibleHeight }}
          showCloseButton={false}
        >
          <div className="relative min-h-full border-t border-[#ddd] pb-[60px]">
            <CategoryTree onNavigate={() => setOpen(false)} />
            <Link
              href="/contact-us"
              className="absolute bottom-0 left-0 flex h-[60px] w-full items-center justify-start border-t border-[#ddd] pl-[20px]"
            >
              <span className={classes.contactIcon}></span>
              <span className="ml-[8px] font-sans text-sm text-primary">
                Contact us
              </span>
            </Link>
          </div>
        </SheetContent>
      </Sheet>
    </>
  )
}

export default NavigationTrigger
